import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalAprobacionPageRoutingModule } from './modal-aprobacion-routing.module';
import { IonicSelectableModule } from 'ionic-selectable';

import { ModalAprobacionPage } from './modal-aprobacion.page';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    IonicSelectableModule,
    ModalAprobacionPageRoutingModule
  ],
  declarations: [ModalAprobacionPage]
})
export class ModalAprobacionPageModule {}
